// import {Subject} from "rxjs"

import {Coordinates} from "./app.interfaces"
import {environment} from "../environments/environment"
import {MW_USER_ID} from "./app.constants"


export function formatLatLon(degreeNumber: number | string): string {
    return Number(degreeNumber).toFixed(3)
}


export function formatCoordinates(coordinates: Coordinates): string {
    return `${formatLatLon(coordinates.latitude)}_${formatLatLon(coordinates.longitude)}`
}


export async function getVersion(): Promise<{binaryAppVersion: string, webAppCompileDate: Date} | null> {
    try {
        const response = await fetch("/assets/version.json")
        const result = await response.json()

        return {
            binaryAppVersion: `${result["binaryAppVersion"]}-${(environment.production) ? "Prod" : "Test"}`,
            webAppCompileDate: new Date(result["webAppCompileDate"])
        }
    } catch (error) {
        console.error(error)
    }

    return null
}


export async function getCompileTime(): Promise<Date | null> {
    try {
        const response = await fetch("/compiletime.txt")
        if (!response || !response.ok) {
            return null
        }
        const text = (await response.text()).trim()
        return new Date(text)
    } catch (error) {
        return null
    }
}


// Liest aus der index.html die Deployment-Info
export function getDeploymentInfo(): string | null {
    const metaElement = document.querySelector('head meta[name="deployment"]')
    if (metaElement) {
        return metaElement.attributes.getNamedItem("content")?.value || null
    }

    return null
}


export function getRandomString() {
    return Math.random().toString(36).substring(2, 7)
}


// export class Queue extends Subject<any> {
//     private items = []
//
//
//     add(item = null) {
//         if (this.observers.length > 0) {
//             this.next(item)
//         } else {
//             this.items.push(item)
//         }
//     }
//
//
//     subscribe(observer) {
//         let s = super.subscribe(observer)
//         this.items.forEach(item => this.next(item))
//         this.items = []
//         return s
//     }
// }


export const shuffleArray = (array: any[]) => {
    if (!array) {
        return array
    }
    if (array?.length < 2) {
        return array
    }
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]]
    }
    return array
}


export async function checkServerConnection() {
    const url = new URL(`${environment.backendBaseUrl}/api/connection`)
    try {
        const response = await fetch(url, {cache: "no-cache"})
        return response.ok
    } catch (e) {
        return false
    }
}


export function getUserId(): string {
    let userId = localStorage.getItem(MW_USER_ID)
    if (!userId) {
        userId = crypto.randomUUID()
        localStorage.setItem(MW_USER_ID, userId)
    }
    return userId
}
